const UserInfoFactory = require('./user-info');
const CompanyFactory = require('./company').instance;
const RestrictionsFactory = require('./restrictions');
const DesygnerApi = require('./desygner-api');

function WorkflowFactory () {
  this.collections = {};
}

WorkflowFactory.prototype.initialize = _.memoize(function () {
  return this.initCredentials()
    .then(_.bind(this.initBaseUrl, this));
});

WorkflowFactory.prototype.initBaseUrl = function () {
  const deferred = $.Deferred();

  CompanyFactory.getCompany().then(_.bind(function (company) {
    this.baseUrl = `${INKIVE.C.API_URL}workflow/companies/${company.id}/`;
    this.companyId = company.id;
    deferred.resolve();
  }, this));

  return deferred.promise();
};

WorkflowFactory.prototype.isEnabled = function () {
  return new Promise((resolve, reject) => {
    RestrictionsFactory.initialize().always((permissions) => {
      if (permissions && permissions.length) {
        _.any(permissions, function (p) { return p.addons && p.addons.workflow !== undefined; })
          ? resolve(true)
          : reject(new Error());
      } else {
        CompanyFactory.getCompanyItems('add_ons').then((addOns) => {
          _.any(addOns, function (a) { return a === 'workflow'; })
            ? resolve(true)
            : reject(new Error());
        });
      }
    });
  });
};

WorkflowFactory.prototype.initCredentials = function () {
  const deferred = $.Deferred();

  UserInfoFactory.get().then(_.bind(function (data) {
    this.credentials = {
      username: data.credentials.token,
      password: data.credentials.hash
    };

    deferred.resolve();
  }, this));

  return deferred.promise();
};

WorkflowFactory.prototype.post = function (resource, element) {
  const deferred = $.Deferred();

  this.initialize().then(_.bind(function (colletion) {
    this.collections[resource] || this._initCollection(resource);

    const model = this.collections[resource].create(element, {
      url: this.baseUrl + resource,
      headers: Backbone.BasicAuth.getHeader({
        username: CONFIG.credentials.token,
        password: CONFIG.credentials.hash
      })
    });

    model.credentials = this.credentials;
    model.on('change:id', deferred.resolve);
    model.on('error', deferred.reject);
  }, this));

  return deferred.promise();
};

WorkflowFactory.prototype.patch = function (resource, job, argument) {
  const deferred = $.Deferred();

  this.initialize().then(() => {
    const endpoint = `workflow/companies/${this.companyId}/${resource}/${job.id}/${argument}`;

    INKIVE.DesygnerApi.patch(endpoint).then(deferred.resolve);
  });

  return deferred.promise();
};

WorkflowFactory.prototype.updateOutputEntity = function (job, data) {
  return new Promise((resolve, reject) => {
    this.initialize().then(() => {
      const projectId = data.info.encoded_id;
      const outputId = job.outputs.find(o => o.info.encoded_id === projectId).id;
      const endpoint = `workflow/companies/${this.companyId}/jobs/${job.id}/outputs/${outputId}`;

      INKIVE.DesygnerApi.patch(endpoint, data).then(resolve);
    });
  });
};

WorkflowFactory.prototype.getJobs = function (design, alias, limit) {
  return new Promise((resolve, reject) => {
    this.initialize().then(() => {
      const endpoint = `workflow/companies/${this.companyId}/linked-jobs/${alias}/${design.id}?limit=${limit || 20}`;

      DesygnerApi.get(endpoint).then(resolve);
    });
  });
};

WorkflowFactory.prototype.getJobById = function (jobId) {
  return new Promise((resolve, reject) => {
    this.initialize().then(() => {
      const endpoint = `workflow/companies/${this.companyId}/jobs/${jobId}`;
      if (jobId) {
        DesygnerApi.get(endpoint).then(resolve);
      } else {
        resolve();
      }
    });
  });
};

WorkflowFactory.prototype._initCollection = function (resource) {
  const Collection = Backbone.Collection.extend({
    model: Backbone.Model,
    url: this.baseUrl + resource
  });

  this.collections[resource] = new Collection();
  this.collections[resource].credentials = this.credentials;
};

const WorkflowFactoryInstance = new WorkflowFactory();
module.exports = WorkflowFactoryInstance;
